// 渠道Logo配置
export const channelLogos = {
  EQUALS_MONEY: {
    emoji: '💰',
    color: '#4CAF50',
    name: 'Equals Money'
  },
  PAGSMILE: {
    emoji: '😊',
    color: '#FF9800',
    name: 'PagSmile'
  },
  SGB: {
    emoji: '🏦',
    color: '#2196F3',
    name: 'SGB'
  },
  LEAN_TECH: {
    emoji: '⚡',
    color: '#9C27B0',
    name: 'Lean Tech'
  },
  PYVIO: {
    emoji: '💳',
    color: '#E91E63',
    name: 'Pyvio'
  },
  PALMPAY: {
    emoji: '🌴',
    color: '#00BCD4',
    name: 'PalmPay'
  },
  KORAPAY: {
    emoji: '🚀',
    color: '#FF5722',
    name: 'KoraPay'
  },
  DURIANPAY: {
    emoji: '🥭',
    color: '#8BC34A',
    name: 'DurianPay'
  },
  BANK_FRICK: {
    emoji: '🏛️',
    color: '#607D8B',
    name: 'Bank Frick'
  },
  BANKING_CIRCLE: {
    emoji: '🔵',
    color: '#3F51B5',
    name: 'Banking Circle'
  },
  BITSO: {
    emoji: '🇲🇽',
    color: '#FF9800',
    name: 'Bitso'
  },
  KKI: {
    emoji: '🏛️',
    color: '#4CAF50',
    name: 'KKI'
  },
  XENDIT: {
    emoji: '⚡',
    color: '#1E90FF',
    name: 'Xendit'
  },
  INSWITCH: {
    emoji: '🔄',
    color: '#FF6F00',
    name: 'Inswitch'
  },
  CHECKOUT: {
    emoji: '✅',
    color: '#0B5CD7',
    name: 'Checkout'
  },
  TAZAPAY: {
    emoji: '💎',
    color: '#00B8D9',
    name: 'Tazapay'
  },
  GENIAL: {
    emoji: '🇧🇷',
    color: '#00695C',
    name: 'Bank Genial'
  },
  CALLPAY: {
    emoji: '🇿🇦',
    color: '#1B5E20',
    name: 'CallPay'
  },
  MDAQ: {
    emoji: '🌏',
    color: '#0066CC',
    name: 'MDAQ'
  }
}

// 获取渠道Logo组件
export const getChannelLogo = (channelCode) => {
  const config = channelLogos[channelCode];
  if (!config) {
    return {
      emoji: '🏢',
      color: '#757575',
      name: channelCode
    };
  }
  return config;
};

// 渠道列头短名映射
export const SHORT_NAMES = {
  BANK_FRICK: 'Frick',
  BANKING_CIRCLE: 'BC',
  EQUALS_MONEY: 'EqMoney',
  LEAN_TECH: 'Lean',
  DURIANPAY: 'Durian',
  KORAPAY: 'Kora',
  PAGSMILE: 'Pag',
  PALMPAY: 'Palm',
  PYVIO: 'Pyvio',
  SGB: 'SGB',
  BITSO: 'Bitso',
  KKI: 'KKI',
  XENDIT: 'Xendit',
  CHECKOUT: 'CK',
  TAZAPAY: 'Tazapay',
  GENIAL: 'Genial',
  CALLPAY: 'CallPay',
  MDAQ: 'MDAQ',
};

/**
 * 构建渠道 Select options（公共复用）
 * @param {string[]} channelCodes - 渠道代码数组
 * @returns {Array<{value: string, label: JSX.Element}>}
 */
export const buildChannelOptions = (channelCodes) => {
  return (channelCodes || []).map(ch => {
    const logo = getChannelLogo(ch);
    return {
      value: ch,
      label: `${logo.emoji} ${SHORT_NAMES[ch] || logo.name} (${ch})`,
    };
  });
};

const CURRENCY_ICONS = {
  USD: '🇺🇸', EUR: '🇪🇺', GBP: '🇬🇧', MXN: '🇲🇽', NGN: '🇳🇬', BRL: '🇧🇷',
  ARS: '🇦🇷', COP: '🇨🇴', VND: '🇻🇳', SGD: '🇸🇬', HKD: '🇭🇰', AUD: '🇦🇺',
  IDR: '🇮🇩', PHP: '🇵🇭', THB: '🇹🇭', MYR: '🇲🇾', KES: '🇰🇪', GHS: '🇬🇭',
  ZAR: '🇿🇦', AED: '🇦🇪', SAR: '🇸🇦', INR: '🇮🇳', JPY: '🇯🇵', CNY: '🇨🇳',
  CHF: '🇨🇭', CAD: '🇨🇦', NZD: '🇳🇿', SEK: '🇸🇪', NOK: '🇳🇴', DKK: '🇩🇰',
  PLN: '🇵🇱', CZK: '🇨🇿', HUF: '🇭🇺', RON: '🇷🇴', BGN: '🇧🇬', TRY: '🇹🇷',
  PEN: '🇵🇪', CLP: '🇨🇱', UYU: '🇺🇾', BOB: '🇧🇴', PYG: '🇵🇾',
};

export const getCurrencyIcon = (code) => CURRENCY_ICONS[code] || '💱';
